import styled, { keyframes } from 'styled-components';

const fadeInUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const gradientShift = keyframes`
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
`;

export const PrivacyContainer = styled.div`
    min-height: 100vh;
    padding: 2rem;
    position: relative;
    overflow: hidden;
    z-index: 1;
    background: linear-gradient(-45deg, #0f0f1f, #1a1a2f, #16213e, #0f3460);
    background-size: 400% 400%;
    animation: ${gradientShift} 15s ease infinite;

    &::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('/img/LogoDuoaColor.png');
        background-size: 400px;
        background-repeat: repeat;
        background-position: center;
        opacity: 0.03;
        z-index: -1;
    }

    @media (max-width: 768px) {
        padding: 1.5rem 1rem;
    }
`;

export const PrivacyContent = styled.div`
    max-width: 900px;
    margin: 0 auto;
    animation: ${fadeInUp} 0.8s ease-out;
`;

export const PageTitle = styled.h1`
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 0.5rem;
    background: linear-gradient(135deg, #ff6b8b, #6b5bff, #4ecdc4);
    background-size: 200% 200%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: ${gradientShift} 3s ease infinite;
    font-weight: 800;
    letter-spacing: -0.02em;

    @media (max-width: 768px) {
        font-size: 2rem;
    }
`;

export const LastUpdated = styled.p`
    text-align: center;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: 3rem;
`;

export const Section = styled.section`
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 15px;
    padding: 1.5rem 2rem;
    margin-bottom: 1.5rem;

    @media (max-width: 768px) {
        padding: 1.25rem 1.25rem;
    }
`;

export const SectionTitle = styled.h2`
    font-size: 1.3rem;
    color: #ff6b8b;
    margin-bottom: 1rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    &::before {
        content: '';
        width: 4px;
        height: 1.3rem;
        background: linear-gradient(135deg, #ff6b8b, #6b5bff);
        border-radius: 2px;
    }
`;

export const Paragraph = styled.p`
    color: rgba(255, 255, 255, 0.85);
    line-height: 1.7;
    margin-bottom: 1rem;
    font-size: 0.95rem;

    &:last-child {
        margin-bottom: 0;
    }

    strong {
        color: white;
        font-weight: 600;
    }

    a {
        color: #6b5bff;
        text-decoration: underline;
        transition: color 0.3s ease;

        &:hover {
            color: #ff6b8b;
        }
    }
`;

export const List = styled.ul`
    color: rgba(255, 255, 255, 0.85);
    line-height: 1.7;
    margin-bottom: 1rem;
    padding-left: 1.5rem;
    font-size: 0.95rem;

    li {
        margin-bottom: 0.5rem;
        position: relative;

        &::marker {
            color: #6b5bff;
        }
    }
`;

export const ContactInfo = styled.div`
    background: rgba(107, 91, 255, 0.1);
    border: 1px solid rgba(107, 91, 255, 0.3);
    border-radius: 10px;
    padding: 1rem 1.5rem;
    margin-top: 1rem;

    p {
        margin: 0.3rem 0;
        color: rgba(255, 255, 255, 0.9);
        font-size: 0.95rem;

        strong {
            color: #6b5bff;
        }
    }

    a {
        color: #4ecdc4;
        text-decoration: none;
        transition: color 0.3s ease;

        &:hover {
            color: #ff6b8b;
            text-decoration: underline;
        }
    }
`;

export const BackLink = styled.a`
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    color: rgba(255, 255, 255, 0.7);
    text-decoration: none;
    margin-bottom: 2rem;
    font-size: 0.95rem;
    transition: color 0.3s ease;

    &:hover {
        color: #6b5bff;
    }

    &::before {
        content: '\u2190';
        font-size: 1.2rem;
    }
`;
